import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateTorneoModal from './modal/createTorneoModal';
import './ATorneo.css';
import API from '../../api/API';
import EdizioneService from '../../api/edizioneService';
import CreateEdizioneModal from './modal/createEdizioneModal';

const Tornei = () => {
  const navigate = useNavigate();
  const [tornei, setTornei] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showCreateEdizioneModal, setShowCreateEdizioneModal] = useState(false);
  const [selectedTorneo, setSelectedTorneo] = useState(null);
  const itemsPerPage = 9;

useEffect(() => {
									 
    const loadTornei = async () => {
      setLoading(true);
      
      try {
        const response = await API.gTorneo.mine();
        console.log(response);
        
        if (response.isSuccess && response.data) {
          setTornei(response.data);
        } else {
          console.error('Errore nel caricamento dei tornei:', response);
          setTornei([]);
        }
      } catch (error) {
        console.error('Errore durante la chiamata API:', error);
        setTornei([]);
      }
      

      setLoading(false);
    };

    loadTornei();
  }, []);
  
  // Filtraggio e ricerca
  const filteredTornei = tornei.filter(torneo => {
    const matchesSearch = torneo.nome.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterStatus === 'all' || torneo.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  // Paginazione
  const totalPages = Math.ceil(filteredTornei.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedTornei = filteredTornei.slice(startIndex, startIndex + itemsPerPage);

  // Gestori eventi
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (e) => {
    setFilterStatus(e.target.value);
    setCurrentPage(1);
  };

  const handleViewTorneo = (torneoId) => {
    console.log('Visualizza torneo:', torneoId);
  };

  const handleEditTorneo = (torneoId) => {
    console.log('Modifica torneo:', torneoId);
  };

  const handleToggleStatus = (nome) => {
    setTornei(prev => prev.map(t => 
      t.nome === nome 
        ? { ...t, status: t.status === 'active' ? 'archived' : 'active' }
        : t
    ));
  };

  const handleSaveEdizione = async (edizioneData) => {
    try {
      // Prepara i dati per l'API nel formato atteso dal backend
      const requestData = {
        torneo: edizioneData.torneo,
        edizione: edizioneData.edizione,
        luogo: edizioneData.luogo,
        categoria: edizioneData.categoria,
        censiti: edizioneData.censiti,
        dataInizio: edizioneData.dataInizio,
        dataFine: edizioneData.dataFine,
        chiusuraIscrizioni: edizioneData.chiusuraIscrizioni,
        chiusuraModifiche: edizioneData.chiusuraModifiche,
        avvio: edizioneData.avvio || null,
        chiusura: edizioneData.chiusura || null,
        quota: edizioneData.quota,
        caparra: edizioneData.caparra || 0,
        cibo: edizioneData.cibo || false,
        preiscrizione: edizioneData.preiscrizione || false,
        locandina: edizioneData.locandina || null,
        foto: edizioneData.foto || null,
        status: edizioneData.status || 'draft'
      };

      const response = await API.torneo.crea(requestData);

      // 202: chi crea ha la scrittura con approvazione, l'edizione esistera' solo quando la richiesta sara' approvata. Aggiungerla adesso alla lista mostrerebbe una riga finta.
      if (response.status === 202) {
        alert(response.data?.messaggio || 'Richiesta inviata: l\'edizione verrà creata dopo l\'approvazione.');
        return;
      }

      if (response.isSuccess) {
        console.log('Edizione creata con successo:', response.data);

        // Aggiorna lo stato locale aggiungendo la nuova edizione al torneo corrispondente
        setTornei(prev => prev.map(t => {
          if (t.nome === edizioneData.torneo) {
            const newEdizione = {
              id: response.data?.id || Date.now(),
              date: edizioneData.dataInizio,
              ...response.data
            };
            return {
              ...t,
              edizioni: [...(t.edizioni || []), newEdizione]
            };
          }
          return t;
        }));
      } else {
        console.error('Errore nella creazione dell\'edizione:', response);
        alert(`Errore nella creazione dell'edizione: ${response.errorMsg || 'riprova.'}`);
      }
    } catch (error) {
      console.error('Errore durante la chiamata API:', error);
      alert('Errore durante la creazione dell\'edizione. Riprova.');
    }
  };

  const handleCreateEdizione = (torneo) => {
    setSelectedTorneo(torneo);
    setShowCreateEdizioneModal(true);
  };

  const handleCloseEdizioneModal = () => {
    setShowCreateEdizioneModal(false);
    setSelectedTorneo(null);
  };

  
  const handleCreateNew = () => {
    setShowCreateModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateModal(false);
  };

  const handleCreateTorneo = async (torneoData) => {
    // Prima restava solo nello stato del browser: adesso il circuito viene creato davvero, e il
    // permesso GRUPPO_TORNEI decide se si puo'. Con la scrittura con check la risposta e' 403
    // finche' la coda delle approvazioni non esiste.
    const res = await API.gTorneo.crea({
      nome: torneoData.nome,
      sottotitolo: torneoData.sottotitolo
    });

    if (!res.isSuccess) {
      alert(res.errorMsg || 'Creazione del torneo non riuscita');
      return;
    }

    const aggiornati = await API.gTorneo.mine();
    if (aggiornati.isSuccess && aggiornati.data) {
      setTornei(aggiornati.data);
    }
  };

  const handleEdizioneClick = (edizione) => {
    EdizioneService.set(edizione);
    navigate('/admin/accettazione');
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return '#27ae60';
      case 'draft': return '#f39c12';
      case 'archived': return '#95a5a6';
      default: return '#3498db';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Attivo';
      case 'draft': return 'Bozza';
      case 'archived': return 'Archiviato';
      default: return 'Sconosciuto';
    }
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
          onClick={() => setCurrentPage(i)}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="tornei-pagination">
        <button
          className="pagination-btn"
          onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
          disabled={currentPage === 1}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        
        {startPage > 1 && (
          <>
            <button className="pagination-btn" onClick={() => setCurrentPage(1)}>1</button>
            {startPage > 2 && <span className="pagination-ellipsis">...</span>}
          </>
        )}
        
        {pages}
        
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="pagination-ellipsis">...</span>}
            <button className="pagination-btn" onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
          </>
        )}
        
        <button
          className="pagination-btn"
          onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
          disabled={currentPage === totalPages}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="tornei-page">
        <div className="tornei-container">
          <div className="tornei-loading">
            <div className="tornei-loading-spinner"></div>
            <p>Caricamento tornei...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="tornei-page">
      <div className="tornei-container">
        {/* Header */}
        <div className="tornei-header">
          <div className="tornei-title">
            <i className="fas fa-trophy"></i>
            <h1>Gestione Tornei</h1>
          </div>
          
          <div className="tornei-stats">
            <div className="tornei-stat">
              <i className="fas fa-calendar"></i>
              <span>Totali: {tornei.length}</span>
            </div>
            <div className="tornei-stat">
              <i className="fas fa-play-circle"></i>
              <span>Attivi: {tornei.filter(t => t.status === 'active').length}</span>
            </div>
            <div className="tornei-stat">
              <i className="fas fa-archive"></i>
              <span>Archiviati: {tornei.filter(t => t.status === 'archived').length}</span>
            </div>
          </div>
          
          <div className="tornei-actions">
            <button className="tornei-btn tornei-btn-success" onClick={handleCreateNew}>
              <i className="fas fa-plus"></i>
              Nuovo Torneo
            </button>
          </div>
        </div>

        {/* Filtri e ricerca */}
        <div className="tornei-filters">
          <div className="tornei-search">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Cerca tornei per nome o sottotitolo..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          
          <select 
            className="tornei-filter-select"
            value={filterStatus}
            onChange={handleFilterChange}
          >
            <option value="all">Tutti gli stati</option>
            <option value="active">Attivi</option>
            <option value="draft">Bozze</option>
            <option value="archived">Archiviati</option>
          </select>
        </div>

        {/* Grid tornei o stato vuoto */}
        {filteredTornei.length === 0 ? (
          <div className="tornei-empty">
            <i className="fas fa-trophy"></i>
            <h3>Nessun torneo trovato</h3>
            <p>
              {searchTerm || filterStatus !== 'all' 
                ? 'Non ci sono tornei che corrispondono ai criteri di ricerca.'
                : 'Non hai ancora creato nessun torneo. Inizia creando il tuo primo torneo!'
              }
            </p>
            {!searchTerm && filterStatus === 'all' && (
              <button className="tornei-btn tornei-btn-success" onClick={handleCreateNew}>
                <i className="fas fa-plus"></i>
                Crea il tuo primo torneo
              </button>
            )}
          </div>
        ) : (
          <>
            <div className="tornei-grid">
              {paginatedTornei.map((torneo) => (
                <div key={torneo.id} className="torneo-card">
                  <div className="torneo-card-header">
                    {/* <div 
                      className="torneo-card-badge"
                      style={{ backgroundColor: getStatusColor(torneo.status) }}
                    >
                      {getStatusText(torneo.status)}
                    </div> */}
                    <h3 className="torneo-card-title">{torneo.nome}</h3>
                    <p className="torneo-card-subtitle">{(torneo.sottotitolo ? torneo.sottotitolo : ' ')}</p>
                  </div>
                  
                  <div className="torneo-card-body">
                    <div className="torneo-card-meta">
                      {/* <div className="torneo-meta-item">
                        <i className="fas fa-medal"></i>
                        <span className="torneo-meta-value">
                          <span className="torneo-edizione-badge">
                            <i className="fas fa-trophy"></i>
                            {torneo.edizioni.length} {torneo.edizioni.length === 1 ? 'Edizione' : 'Edizioni'}
                          </span>
                        </span>
                      </div> */}
                      <div className="torneo-meta-item">
                        <i className="fas fa-calendar-alt"></i>
                        <div className="torneo-meta-value">
                          <div className="edizioni-label">Edizioni:</div>
                          <div className="edizioni-buttons">
                            {torneo.edizioni && torneo.edizioni.length > 0 ? (
                              torneo.edizioni
                                .sort((a, b) => new Date(b.dataInizio || b.date) - new Date(a.dataInizio || a.date))
                                .map((edizione) => {
                                  const dataFormattata = edizione.date ? new Date(edizione.date).toLocaleDateString('it-IT') : 'N/D';
                                  return (
                                    <button
                                      key={edizione.id}
                                      className="edizione-btn"
                                      onClick={() => handleEdizioneClick(edizione)}
                                      title={`Vai all'edizione del ${dataFormattata}`}
                                    >
                                      {dataFormattata}
                                    </button>
                                  );
                                })
                            ) : (
                              <span className="no-edizioni">Nessuna edizione</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="torneo-card-actions">
                    <button 
                      className={`torneo-btn ${torneo.status === 'active' ? 'torneo-btn-delete' : 'torneo-btn-view'}`}
                      onClick={() => handleCreateEdizione(torneo)}
                      title={'NewEdition'}
                    >
                      <i className={`fas fa-plus`}></i>
                      Nuova edizione
                    </button>

                    <button 
                      className={`torneo-btn ${torneo.status === 'active' ? 'torneo-btn-delete' : 'torneo-btn-view'}`}
                      onClick={() => handleToggleStatus(torneo.nome)}
                      title={torneo.status === 'active' ? 'Disattiva torneo' : 'Attiva torneo'}
                    >
                      <i className={`fas fa-chart-simple`}></i>
                      Statistiche
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Paginazione */}
            {renderPagination()}
          </>
        )}

        {/* Modal per creazione nuovo torneo */}
        <CreateTorneoModal
          isOpen={showCreateModal}
          onClose={handleCloseModal}
          onSubmit={handleCreateTorneo}
        />

        {/* Modal per creazione nuova edizione */}
        <CreateEdizioneModal
          isOpen={showCreateEdizioneModal}
          onClose={handleCloseEdizioneModal}
          onSubmit={handleSaveEdizione}
          selectedTorneo={selectedTorneo}
          torneiDisponibili={tornei.map(t => t.nome)}
        />
      </div>
    </div>
  );
};

export default Tornei;